module.exports = __webpack_public_path__ + "fonts/Sen-Regular.1695bb84.woff2";